import React, { createContext, useEffect, useRef, useState } from "react";

export const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
	const [user, setUser] = useState("");
	const [userId, setUserId] = useState("");
	const defaultSavedReadingsObj = [
		{
			readingId: "",
			question: "",
			cardName: "",
			cardImage: "",
			description: "",
			date: "",
		},
	];
	const [savedReadings, setSavedReadings] = useState(defaultSavedReadingsObj);
	const [readingsFeed, setReadingsFeed] = useState(false);

	const firstUpdate = useRef(true);
	useEffect(() => {
		if (firstUpdate.current) {
			firstUpdate.current = false;
			return;
		}
		fetch(`${process.env.REACT_APP_API_URL}/users/${user}`)
			.then((res) => res.json())
			.then((data) => {
				if (data.data !== null) {
					setSavedReadings(() => data.data.readingData);
					setUserId(() => data.data._id);
				}
				setReadingsFeed(false);
			});
	}, [setSavedReadings, readingsFeed, user]);

	return (
		<UserContext.Provider
			value={{
				user,
				setUser,
				userId,
				setUserId,
				savedReadings,
				setSavedReadings,
				readingsFeed,
				setReadingsFeed,
			}}
		>
			{children}
		</UserContext.Provider>
	);
};
